import { faListDots } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  BoxV4,
  NoteColors,
  NoteV2,
  SelectV4,
  TextInputV4,
} from '@labrav/react-components'
import { useStyles } from './CombinedFormProductSelection.styles'
import { FormikProps, useFormikContext } from 'formik'
import { MsftCombinedFormState } from '../../../modules/microsoftCombinedForm/reducer'

import { get } from 'lodash'
import { DataType } from '@labrav/react-components/lib/@types/types/forms'
import { useSelector } from '../../../store'
import { Product } from '../../../modules/productsListing/reducer'
import { SelectChangeEvent } from '@mui/material'
import { MicrosoftFlyOutListingData } from '../../../types/flyout'

export const CombinedFormProductSelection = ({
  disableProductSelection,
  disabled,
}: {
  disableProductSelection: boolean
  disabled?: boolean
}) => {
  const queryParams = new URLSearchParams(location.search)
  const labraIsvAccountId = queryParams.get('labra_isv_id') as string

  const { classes } = useStyles()

  const { microsoftSellerInfo } = useSelector<{
    microsoftSellerInfo: MicrosoftFlyOutListingData
  }>(state => ({
    microsoftSellerInfo: state.flyOutSellerInfoMicrosoft || {},
  }))

  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext() as FormikProps<MsftCombinedFormState>

  const { AZURE } = useSelector(state => state.productsListing)

  const isIsvCPSame = values.labraResellerId === labraIsvAccountId

  const productSelectOptions = ((AZURE?.products?.rows || []) as Product[])
    .filter(product => product?.productName)
    .map(product => ({
      label: product.productName,
      value: product.productId,
      key: product.productId,
    }))

  const handleProductChange = (event: SelectChangeEvent) => {
    const selectedProductId = event.target.value as string

    setFieldValue('draftOffer.labraProductId', selectedProductId)

    const cloudProductId =
      AZURE?.products?.rows?.find(
        (product: Product) => product.productId === selectedProductId
      )?.cloudMarketplaceProductId || ''

    setFieldValue('draftOffer.cloudProductId', cloudProductId)
  }

  return (
    <BoxV4
      heading={'Select a product'}
      headingIcon={
        <FontAwesomeIcon
          icon={faListDots}
          style={{ width: '20px', height: '16px' }}
        />
      }
    >
      <div className={classes.sectionContainer}>
        <div className={classes.companyDetailsContainer}>
          <div className={classes.inputWidth}>
            <TextInputV4
              keyName="vendor"
              title="Vendor name"
              type="text"
              placeHolder=""
              value={microsoftSellerInfo?.sellerName || ''}
              updatedValue={microsoftSellerInfo?.sellerName || ''}
              isError={false}
              onChange={() => void 0}
              isReadOnly={true}
              isRequired={false}
              errorText={''}
              showSpinner={false}
            />
          </div>
          <div className={classes.inputWidth}>
            <SelectV4
              field={{
                title: 'Select a product',
                placeHolder: 'Select a product',
                id: 'draftOffer.labraProductId',
                isRequired: false,
                humanReadableKey: 'product-selection',
                isReadOnly: disabled || disableProductSelection,
                isCustom: false,
                defaultValue: values.draftOffer?.labraProductId,
                value: values.draftOffer?.labraProductId,
                dataType: 'enum' as DataType,
                options: productSelectOptions,
                disabled: disabled,
              }}
              value={values.draftOffer?.labraProductId}
              onChange={handleProductChange}
              showInsideInfoIcon={true}
              showInsideInfoIconTooltip={{
                title: '',
                content:
                  'This field displays all the products listed by the selected ISV (Vendor) that are available for creating an offer.',
              }}
              isError={
                !!(
                  get(touched, `draftOffer.labraProductId`, false) &&
                  get(errors, `draftOffer.labraProductId`, false)
                )
              }
              errorText={
                (!!get(touched, `draftOffer.labraProductId`, false) &&
                  get(errors, `draftOffer.labraProductId`, '')) ||
                ''
              }
              size={'small'}
              minWidth="389px"
              onBlur={handleBlur}
            />
          </div>
        </div>
        {isIsvCPSame && (
          <div className={classes.noteWrapper}>
            <NoteV2
              description={
                <>
                  <span className={classes.nameBoldText}>Warning:</span>{' '}
                  <span>
                    The provided reseller and ISV accounts belong to the same
                    Microsoft tenant and the offer processing might fail
                  </span>
                </>
              }
              backgroundColor={NoteColors.YELLOW}
            />
          </div>
        )}
      </div>
    </BoxV4>
  )
}
